export default "__VITE_ASSET__B2HYjZv1__"